import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, createStaticVNode as _createStaticVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4c361d54"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/_createStaticVNode("<div class=\"row justify-content-center mb-1\" data-v-4c361d54><h1 class=\"col-6 regist-h\" data-v-4c361d54>会員情報のご確認</h1></div><div class=\"row mb-2\" data-v-4c361d54><div class=\"col-6 text-small\" data-v-4c361d54>ご入力内容を確認してください。</div></div><div class=\"row\" data-v-4c361d54><div class=\"col-6 text-small\" data-v-4c361d54><b data-v-4c361d54>会員情報</b></div></div>", 3)
const _hoisted_4 = { class: "row justify-content-center" }
const _hoisted_5 = { class: "col-12" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "姓", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "名", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "郵便番号", -1))
const _hoisted_9 = { colspan: "3" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "都道府県", -1))
const _hoisted_11 = { colspan: "3" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "住所1", -1))
const _hoisted_13 = { colspan: "3" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "住所2", -1))
const _hoisted_15 = { colspan: "3" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "住所3", -1))
const _hoisted_17 = { colspan: "3" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "メール", -1))
const _hoisted_19 = { colspan: "3" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "電話番号", -1))
const _hoisted_21 = { colspan: "3" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "性別", -1))
const _hoisted_23 = { colspan: "3" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "生年月日", -1))
const _hoisted_25 = { colspan: "3" }
const _hoisted_26 = { class: "row justify-content-center mt-2" }
const _hoisted_27 = { class: "col-12 text-center" }
const _hoisted_28 = { class: "row justify-content-center mt-3" }
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-12 text-center modal-header" }, " 登録エラー ", -1))
const _hoisted_30 = { class: "col-12 text-center" }
const _hoisted_31 = { class: "col-12 text-center" }

import {ref, reactive, inject, onMounted, toRefs} from 'vue'
import { Auth, DataStore, Predicates } from 'aws-amplify';
import { useRouter } from 'vue-router';
import { Member, MemberType, RegistrationCode, Shop } from '@/models';
import Modal from '../../components/Modal.vue'
import { useCookies } from 'vue3-cookies';

interface Props {
  member: Member;
}

export default /*#__PURE__*/_defineComponent({
  props: {
    member: null
  },
  emits: ['startLoading', 'stopLoading'],
  setup(__props: any, { emit }) {

const props = __props as {
  member: Member;
}






const router = useRouter();
const {cookies} = useCookies();

const form = ref<any>({});

const error = ref('');

const createMember = async () => {
  emit('startLoading');
  try {
    const user = await Auth.currentUserInfo();

    const chkMember = await DataStore.query(Member, (m) => m.cogUser('eq', user.username));
    if (chkMember.length > 0) {
      error.value = 'すでに登録されています';
      emit('stopLoading');
      return;
    }

    const shopId: any = cookies.get('shopId');
    console.log(shopId);
    const buf = await DataStore.query(Shop, (s) => s.id('eq', shopId));
    const shop: Shop = buf[0];

    /*const defaultMemberType = (await DataStore.query(MemberType, 
      (mt) => mt.isDefault('eq', true).groupID('eq', shop.groupID!)))[0];*/

    const member = await DataStore.save(new Member({
      name: form.value.familyName + form.value.givenName,
      cogUser: user.username,
      email: form.value.email,
      birthday: form.value.birthY+'-'+form.value.birthM+'-'+form.value.birthD,
      gender: parseInt(form.value.gender),
      tel: form.value.tel,
      postCode: form.value.postCode,
      address: form.value.pref + form.value.address1 + form.value.address2 + (form.value.address3 ? form.value.address3  : ''), 
      point: 0,
      status: 1,
      //memberType: defaultMemberType,
      cardFamilyName: form.value.familyName,
      cardGivenName: form.value.givenName,
      cardCountry: "JP",
      cardPref: form.value.pref,
      cardAddress1: form.value.address1,
      cardAddress2: form.value.address2,
      cardAddress3: form.value.address3,
      shopID: shop.id,
      groupID: shop.groupID,
    }));

    if (!member) {
      return;
    }

    const memberList = (await DataStore.query(Member, Predicates.ALL))
      .sort((a, b) => b.codeNum! - a.codeNum!);

    const nextCode: number = !memberList[0].codeNum ? 1 : memberList[0].codeNum + 1;

    await DataStore.save(
      Member.copyOf(member , updated => {
        updated.codeNum = nextCode;
      })
    );

    await DataStore.delete(RegistrationCode, (c) => c.email('eq', form.value.email));

    cookies.remove('registration_form');
    cookies.remove('verify_code');

    router.push('/registration/success');
  }
  catch(e) {
    console.log(e);
    error.value = error.value == '' ? '登録に失敗しました。' : error.value;
    emit('stopLoading');
  }
}

onMounted(async() => {
  form.value = cookies.get('registration_form');
  emit('stopLoading');
});


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("table", null, [
          _createElementVNode("tbody", null, [
            _createElementVNode("tr", null, [
              _hoisted_6,
              _createElementVNode("td", null, _toDisplayString(form.value.familyName), 1),
              _hoisted_7,
              _createElementVNode("td", null, _toDisplayString(form.value.givenName), 1)
            ]),
            _createElementVNode("tr", null, [
              _hoisted_8,
              _createElementVNode("td", _hoisted_9, _toDisplayString(form.value.postCode), 1)
            ]),
            _createElementVNode("tr", null, [
              _hoisted_10,
              _createElementVNode("td", _hoisted_11, _toDisplayString(form.value.pref), 1)
            ]),
            _createElementVNode("tr", null, [
              _hoisted_12,
              _createElementVNode("td", _hoisted_13, _toDisplayString(form.value.address1), 1)
            ]),
            _createElementVNode("tr", null, [
              _hoisted_14,
              _createElementVNode("td", _hoisted_15, _toDisplayString(form.value.address2), 1)
            ]),
            _createElementVNode("tr", null, [
              _hoisted_16,
              _createElementVNode("td", _hoisted_17, _toDisplayString(form.value.address3), 1)
            ]),
            _createElementVNode("tr", null, [
              _hoisted_18,
              _createElementVNode("td", _hoisted_19, _toDisplayString(form.value.email), 1)
            ]),
            _createElementVNode("tr", null, [
              _hoisted_20,
              _createElementVNode("td", _hoisted_21, _toDisplayString(form.value.tel), 1)
            ]),
            _createElementVNode("tr", null, [
              _hoisted_22,
              _createElementVNode("td", _hoisted_23, _toDisplayString(form.value.gender == 0 ? '男性' : '女性'), 1)
            ]),
            _createElementVNode("tr", null, [
              _hoisted_24,
              _createElementVNode("td", _hoisted_25, _toDisplayString(form.value.birthY) + "年" + _toDisplayString(form.value.birthM) + "月" + _toDisplayString(form.value.birthD) + "日", 1)
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", { class: "row mt-3" }, [
      _createElementVNode("div", { class: "col-12 text-center" }, [
        _createElementVNode("button", {
          class: "btn btn-primary",
          onClick: createMember
        }, "確認しました")
      ])
    ]),
    _createElementVNode("div", _hoisted_26, [
      _createElementVNode("div", _hoisted_27, [
        _createElementVNode("button", {
          type: "button",
          class: "btn-white btn-back",
          onClock: _cache[0] || (_cache[0] = ($event: any) => (_unref(router).push('/registration/form')))
        }, "前の画面に戻る", 32)
      ])
    ]),
    _createVNode(Modal, {
      visible: error.value != '',
      onHide: _cache[2] || (_cache[2] = ($event: any) => (error.value = ''))
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_28, [
          _hoisted_29,
          _createElementVNode("div", _hoisted_30, _toDisplayString(error.value), 1),
          _createElementVNode("div", _hoisted_31, [
            _createElementVNode("button", {
              type: "button",
              class: "btn-white btn-back",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (error.value = ''))
            }, "閉じる")
          ])
        ])
      ]),
      _: 1
    }, 8, ["visible"])
  ], 64))
}
}

})